<template>
    <div>
        <button class="btn btn-outline-dark" @click="getClasses(); show = !show">Add Student Update</button>
        <div v-if="show">
            <br />
            <v-select label="Class" :items="classes" v-model="selectedClass"></v-select>
            <v-text-field label="Email" v-model="email" :error-messages="emailErr"></v-text-field>
            <v-textarea auto-grow label="Update" rows="1" v-model="update"></v-textarea>
            <button
                class="btn btn-sm btn-outline-success mt-3"
                :disabled="!complete || !update || !selectedClass"
                @click="submit()"
            >Submit</button>
        </div>
    </div>
</template>

<script>
import { debounce } from "lodash";
import { mapState } from "vuex";
const fb = require("../../firebaseConfig");
export default {
    data() {
        return {
            show: false,
            email: "",
            classes: [],
            selectedClass: "",
            update: "",
            complete: false,
            emailErr: ""
        };
    },
    watch: {
        // whenever question changes, this function will run
        email: function(newVal, oldVal) {
            this.emailErr = "";
            this.complete = false;
            this.debouncedChange();
        }
    },
    created() {
        this.debouncedChange = debounce(this.change, 2000);
    },
    computed: {
      ...mapState(["userProfile", "admin"])
    },
    methods: {
        getClasses() {
            if (this.classes.length) {
                return;
            }
            if (this.admin) {
                fb.db
                    .collection("classes")
                    .where("active", "==", true)
                    .get()
                    .then(qs => {
                        qs.forEach(doc => {
                            if (this.show) {
                                this.classes.push(doc.data().name);
                            }
                        });
                    });
            } else {
                this.classes = this.userProfile.classes;
            }
        },
        change() {
            if (!this.email) {
                return;
            }
            fb.db
                .collection("users")
                .where("type", "==", "student")
                .where("email", "==", this.email.toLowerCase())
                .get()
                .then(qs => {
                    if (qs.empty) {
                        this.emailErr = "No student found";
                    } else {
                        fb.db
                            .collection("classes")
                            .where("name", "==", this.selectedClass)
                            .where(
                                "students",
                                "array-contains",
                                this.email.toLowerCase()
                            )
                            .get()
                            .then(qs => {
                                if (qs.empty) {
                                    this.emailErr = `User not in class`;
                                } else {
                                    this.complete = true;
                                }
                            });
                    }
                });
        },
        submit() {
            fb.db.collection("updates").add({
                student: this.email.toLowerCase(),
                class: this.selectedClass,
                update: this.update,
                timestamp: fb.firebase.firestore.FieldValue.serverTimestamp()
            }).then(() => {
                this.$emit('toast', 'suc', 'Successfully added student update.')
            })
            this.email = "";
            this.selectedClass = "";
            this.update = "";
            this.show=false;
        }
    }
};
</script>